<div class="d-flex flex-row">
    <input
        #krInput
        [disabled]="disabled"
        class="kr-input text-end"
        type="text"
        (focus)="krInput.select()"
        (keyup)="keyup()"
        (change)="onChangeKr(krInput.value, beskrivelseInput.value)"
        [value]="kr === 0 ? '' : kr | currency:'DKK':'':'1.2-2':'da'"
    />
    <span class="d-inline-block" [ngbTooltip]="beskrivelse || ''">
        <input
            #beskrivelseInput
            [disabled]="krInput.value === '' || +krInput.value === 0 || disabled"
            class="beskrivelse-input"
            type="text"
            maxlength="255"
            (focus)="beskrivelseInput.select()"
            (change)="onChangeBeskrivelse(beskrivelseInput.value)"
            [value]="beskrivelse || ''"
        />
    </span>
</div>
